const citySelect = function ($mod) {
    let $selectArea = $mod.find('.select-area');
    let $head = $mod.find('.top-bar-block');

    setTimeout(()=> {
        $head.find('span').click(function (e) {
            $head.find('span').removeClass('target');
            $(e.target).addClass('target');
            const index = document.getElementsByClassName('index');
            for (let i = 0; i < index.length; i++) {
                if (index[i].innerText === e.target.innerText && index[i].offsetTop !== 0) {
                    $(index[i]).addClass('target');
                    $selectArea.animate({
                        scrollTop: index[i].offsetTop - 56
                    });
                } else {
                    $(index[i]).removeClass('target');
                }
            };
        })
        $selectArea.find('.city-item').click(function(e) {
            const id = $(e.target).data('id');
            const name = e.target.innerText;
            $('.city-select').attr('city_id', id);
            $('.city-select').attr('city_name', name);
            $('.city-select').find('.text-info').text(name);
            $('.city-select').find('.text-info').addClass('black')
            $('body').click();
        });
        const city = $('.city-select-container').data('cityname');
        const cities = $selectArea.find('.city-item');
        for (let i = 0; i< cities.length; i++) {
            if (cities.eq(i).text() === city) {
                cities.eq(i).click();
            }
        }
    }, 1000)
}
module.exports = citySelect;


// WEBPACK FOOTER //
// ./src/component/cityselect/index.js